const toEnglishDigits = (str) => {
  if (typeof str !== "string") return str;

  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';

  return str
    .replace(/[۰-۹]/g, (w) => persianDigits.indexOf(w))
    .replace(/[٠-٩]/g, (w) => arabicDigits.indexOf(w));
}

const toFarsiDigits = (str, separateThousands = false) => {
  if (typeof str !== "string") return str;

  const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
  // const arabicDigits  = '٠١٢٣٤٥٦٧٨٩';

  let result = str;

  if (separateThousands) {
    result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    result = result.replace(/\d/g, (d) => persianDigits[d]);
  }
  else {
    result = result.replace(/\d/g, (d) => persianDigits[d]);
  }

  return result;


}


const timeUntil = (dateString) => {

  if (!dateString) {
    return { value: null, unit: null, message: "هنوز ست نشده", original: null };
  }

  const now = new Date();
  const target = new Date(dateString);

  const diffMs = target - now; // اختلاف به میلی‌ثانیه
  if (diffMs <= 0) {
    return { value: 0, unit: "الان", message: "زمان رسیده", original: target };
  }

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays > 0) {
    if (diffDays === 1) {
      return { value: 1, unit: "روز", message: "فردا" , original: target};
    }
    return { value: diffDays, unit: "روز", message: `${diffDays} روز مانده`, original: target };
  }

  if (diffHours > 0) {
    return { value: diffHours, unit: "ساعت", message: `${diffHours} ساعت مانده` , original: target};
  }

  if (diffMinutes > 0) {
    return { value: diffMinutes, unit: "دقیقه", message: `${diffMinutes} دقیقه مانده`, original: target };
  }

  return { value: 0, unit: "الان", message: "الان" , original: target};
}


export default {
  toEnglishDigits,
  toFarsiDigits,
  timeUntil

}

